import type { PriceVenue, Resolution } from '@api/api/price-schema';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { fetchPrices } from '@terminal/services/price/price-service';

const QUERY_KEY_PRICE_HISTORY = 'QUERY_KEY_PRICE_HISTORY';

interface UsePriceHistoryProps extends PriceVenue {
  entityTag: string;
  resolution?: Resolution;
  dateFrom?: string;
  dateTo?: string;
  ticker?: string;
  enabled?: boolean;
}

export const usePriceHistory = ({
  entityTag,
  resolution = '1D',
  dateFrom,
  dateTo,
  ticker,
  exchange,
  country,
  enabled = true,
}: UsePriceHistoryProps) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_PRICE_HISTORY,
      entityTag,
      resolution,
      dateFrom,
      dateTo,
      ticker,
      exchange,
      country,
    ],
    queryFn: () =>
      fetchPrices({
        entityTag,
        resolution,
        dateFrom,
        dateTo,
        ticker,
        exchange,
        country,
      }),
    staleTime: getTimeTillEndOfDayMs(),
    enabled,
  });
};
